import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, FileText, Mail } from "lucide-react";
import { Button, Spinner } from "@porchpass/ui";
import { useWorkspace } from "./WorkspaceContext";
import { formatLoanDetails } from "../utils";

export function WorkspaceHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ??
    "/pre-approval";
  const {
    externalId,
    application,
    actionState,
    handleGenerate,
    openSendModal,
  } = useWorkspace();

  const isGenerating = actionState === "generating";
  const borrower = application?.borrower;

  return (
    <header className="flex items-center justify-between h-[72px] px-6 border-b border-[#E4E7EC] bg-white shrink-0">
      <div className="flex items-center gap-4 min-w-0">
        <Button
          variant="secondary"
          size="icon"
          onClick={() => navigate(returnTo)}
          aria-label="Back to search"
        >
          <ArrowLeft className="h-4 w-4 text-[#697083]" />
        </Button>
        <div className="min-w-0">
          <h1 className="text-lg font-semibold text-[#101827] truncate">
            {borrower?.full_name ?? `Application ${externalId}`}
          </h1>
          <div className="flex flex-wrap items-center gap-3 text-xs text-[#697083]">
            {borrower ? (
              <>
                <span>{borrower.phone_number ?? "Not available"}</span>
                <span>{borrower.email ?? "Not available"}</span>
                <span>
                  {application?.application_status ?? "Unknown status"}
                </span>
              </>
            ) : (
              <span>Loading borrower details...</span>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <div className="hidden lg:flex items-center gap-4 rounded-xl bg-[#F3F5F8] px-4 py-2 text-xs">
          <div>
            <div className="text-[#9AA2B2]">Loan details</div>
            <div className="font-semibold text-[#697083]">
              {formatLoanDetails(application?.loan)}
            </div>
          </div>
        </div>

        <Button
          variant="secondary"
          size="s"
          onClick={() => {
            void handleGenerate().catch(() => undefined);
          }}
          disabled={isGenerating}
        >
          {isGenerating ? (
            <Spinner size="s" />
          ) : (
            <FileText className="h-4 w-4" />
          )}
          Regenerate Letter
        </Button>

        <Button
          size="s"
          onClick={() => {
            void openSendModal();
          }}
          disabled={isGenerating}
        >
          <Mail className="h-4 w-4" />
          Send Pre-Approval
        </Button>
      </div>
    </header>
  );
}
